var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/Project/ProjectBottom.jinja"] = require( "front/components/Project/ProjectBottom.jinja" );
dependencies["front/components/ProjectSide/ProjectSide.jinja"] = require( "front/components/ProjectSide/ProjectSide.jinja" );
dependencies["front/components/IntroText/IntroText.jinja"] = require( "front/components/IntroText/IntroText.jinja" );
dependencies["front/components/BtnClose/BtnClose.jinja"] = require( "front/components/BtnClose/BtnClose.jinja" );
dependencies["front/components/Frame/Frame.jinja"] = require( "front/components/Frame/Frame.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectPage.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/Project/ProjectBottom.jinja", false, "ProjectPage.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("ProjectBottom", t_1);
env.getTemplate("front/components/ProjectSide/ProjectSide.jinja", false, "ProjectPage.jinja", function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("ProjectSide", t_4);
env.getTemplate("front/components/IntroText/IntroText.jinja", false, "ProjectPage.jinja", function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("IntroText", t_7);
env.getTemplate("front/components/BtnClose/BtnClose.jinja", false, "ProjectPage.jinja", function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
context.setVariable("BtnClose", t_10);
output += "<div class=\"ProjectPage\">\n    <div class=\"PageTitle\">\n        <h1 class=\"PageTitle-content u-Heading\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"title")), env.opts.autoescape);
output += "</h1>\n    </div>\n\n    <article class=\"Project\">\n";
output += "\n";
output += "\n                <div class=\"Hero\">\n                    ";
env.getTemplate("front/components/Frame/Frame.jinja", false, "ProjectPage.jinja", function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n                    <div class=\"Hero-img u-Preload u-Cover\">\n                        <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"img")),"main"), env.opts.autoescape);
output += "\" srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"img")),"main_2x"), env.opts.autoescape);
output += " 2x\"\n                             alt=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "project")),"title")), env.opts.autoescape);
output += "\">\n                    </div>\n\n                    <button class=\"Hero-btn u-Btn\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Hero/Hero-btn.svg")), env.opts.autoescape);
output += "\n                    </button>\n                </div>\n\n                <div class=\"Project-top\">\n                    ";
output += runtime.suppressValue((lineno = 27, colno = 45, runtime.callWrap(runtime.memberLookup((t_7),"IntroText"), "IntroText[\"IntroText\"]", context, [runtime.contextOrFrameLookup(context, frame, "project"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_18 = "";;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
output += "\n                </div>\n";
output += "\n\n";
output += "\n                ";
output += runtime.suppressValue((lineno = 32, colno = 49, runtime.callWrap(runtime.memberLookup((t_1),"ProjectBottom"), "ProjectBottom[\"ProjectBot\"]", context, [runtime.contextOrFrameLookup(context, frame, "project"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_19 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_20 = "";;
frame = frame.pop();
return new runtime.SafeString(t_20);
});
return macro_t_19;})()})])), env.opts.autoescape);
output += "\n";
output += "\n";
output += "\n        <div class=\"Project-overlay\"></div>\n\n        <div class=\"Project-close\">\n            ";
output += runtime.suppressValue((lineno = 38, colno = 35, runtime.callWrap(runtime.memberLookup((t_10),"BtnClose"), "BtnClose[\"BtnClose\"]", context, ["a",(lineno = 38, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["offcon:project-list"])),runtime.makeKeywordArgs({"caller": (function (){var macro_t_21 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_22 = "";;
frame = frame.pop();
return new runtime.SafeString(t_22);
});
return macro_t_21;})()})])), env.opts.autoescape);
output += "\n        </div>\n    </article>\n\n    ";
output += runtime.suppressValue((lineno = 42, colno = 33, runtime.callWrap(runtime.memberLookup((t_4),"ProjectSide"), "ProjectSide[\"ProjectSid\"]", context, [runtime.contextOrFrameLookup(context, frame, "projects"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_23 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_24 = "";;
frame = frame.pop();
return new runtime.SafeString(t_24);
});
return macro_t_23;})()})])), env.opts.autoescape);
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectPage.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/ProjectPage/ProjectPage.jinja
// module id = 74
// module chunks = 0